export let validatePassword = (passwordPolicy, validator, password) => {
    if (passwordPolicy) {
        for (let key in passwordPolicy.data.regex_policy) {
            if (validator === key) {
                let pattern = new RegExp(passwordPolicy.data.regex_policy[key].pattern);
                return pattern.test(password);
            }
        }
    }
    return false;
};

export let validateAll = (passwordPolicy, password) => {
    if (passwordPolicy) {
        for (let key in passwordPolicy.data.regex_policy) {
            if (!validatePassword(passwordPolicy, key, password)) {
                return false;
            }
        }
        return true;
    }
};
